import { DefaultStorage } from 'shared/tools';
import { CONSUMER_CODE_KEY } from './consumerCodeKey';

export function createConsumerCodeStorage(): DefaultStorage {
  return new DefaultStorage(localStorage, CONSUMER_CODE_KEY);
}
